(function(angular){
	'use strict';

	var transactionActivityTableObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			transactions: '<',
			enableFilters: '<'
		},
		controller: [
			'$rootScope',
			'$timeout',
			'APP_BASE_PATH',
			'INVESTMENT_ENTITY_ID',
			'InvestmentEntityFactory',
			'mixpanelFactory',
			'moment',
			'urlFactory',
			TransactionActivityTableFunction
		],
		controllerAs: 'transactionActivityTable'
	};

	angular
		.module('transactionActivityTableModule')
		.component('transactionActivityTable', transactionActivityTableObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/investor-dashboard/transactions/transaction-activity-table.html';
	}

	function TransactionActivityTableFunction(
		$rootScope,
		$timeout,
		APP_BASE_PATH,
		INVESTMENT_ENTITY_ID,
		InvestmentEntityFactory,
		mixpanelFactory,
		moment,
		urlFactory
	) {
		var transactionActivityTable = this;

		function getDateOptions() {
			var oldestTransactionDate = new Date();

			angular.forEach(transactionActivityTable.transactions, function(transaction) {
				if (moment(transaction.date).isBefore(oldestTransactionDate)) {
					oldestTransactionDate = transaction.date;
				}
			});

			var possibleDateOptions = [
				{'value':moment().subtract(1, 'months'), 'label':'Last month'},
				{'value':moment().subtract(3, 'months'), 'label':'Last 3 months'},
				{'value':moment().subtract(6, 'months'), 'label':'Last 6 months'},
				{'value':moment().subtract(1, 'years'), 'label':'Last year'}
			];

			var dateOptions = [{'value':0, 'label':'All dates'}];

			for (var i = 0; i < possibleDateOptions.length; i++) {
				dateOptions.push(possibleDateOptions[i]);
				if (moment(oldestTransactionDate).isAfter(possibleDateOptions[i].value)) {
					break;
				}
			}

			return dateOptions;
		}

		function getTypeOptions() {
			var typeToTitleMap = {'ALL_TRANSACTIONS': 'All types'};
			angular.forEach(transactionActivityTable.transactions, function(transaction) {
				typeToTitleMap[transaction.type] = transaction.title;
			});

			return Object.keys(typeToTitleMap).map(function(type) {
				return {
					'value': type,
					'label': typeToTitleMap[type]
				};
			});
		}

		transactionActivityTable.dateFilterFunction = function(transaction) {
			return moment(transaction.date).isAfter(transactionActivityTable.dateFilter.value);
		};

		transactionActivityTable.typeFilterFunction = function(transaction) {
			return transactionActivityTable.typeFilter.value === 'ALL_TRANSACTIONS' ||
					transactionActivityTable.typeFilter.value === transaction.type;
		};

		transactionActivityTable.collapseAll = function() {
			angular.forEach(transactionActivityTable.transactions, function(transaction) {
				transaction.expanded = false;
			});
		};

		transactionActivityTable.fireCancellationMixpanelEvent = function(orderGroupDto, cancellationPreviewDto, cancelType) {
			transactionActivityTable.cancelTransactionData = {
				reitInvestmentOrderGroupId: orderGroupDto.id,
				reitInvestmentOrderGroupVersion: orderGroupDto.version,
				amount: orderGroupDto.totalRequestedValue,
				investment : orderGroupDto.investmentName,
				cancelType : cancelType,
				newServiceLevel : cancellationPreviewDto.serviceLevel,
				newInvestmentGoalSelection : cancellationPreviewDto.investmentGoalSelection,
				newRiaPlanType : cancellationPreviewDto.riaPlanType
			};

			mixpanelFactory.track("Show Cancel Transaction Modal", transactionActivityTable.cancelTransactionData);
		};

		transactionActivityTable.showRejectModal = function(orderGroupDto) {
			urlFactory.apiGetPromise('/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group/' + orderGroupDto.id + '/cancel-preview').then(function(response) {
				if (orderGroupDto.investmentCancellationEligibility === 'CAN_REJECT') {
					transactionActivityTable.fireCancellationMixpanelEvent(orderGroupDto, response.data, 'cancel-transaction');
					$rootScope.ModalFactory.openCancelTransaction(transactionActivityTable.cancelTransactionData);
				} else if (orderGroupDto.investmentCancellationEligibility === 'CAN_MARK_REFUND_UPON_SETTLEMENT') {
					transactionActivityTable.fireCancellationMixpanelEvent(orderGroupDto, response.data, 'cancel-transaction-upon-settlement');
					$rootScope.ModalFactory.openCancelTransaction(transactionActivityTable.cancelTransactionData);
				}
			});
		};

		function fireChangeBankAccountMixpanelEvent(transaction) {
			mixpanelFactory.track("Change Bank Account Modal Opened", {
				"REIT Investment Order Group Id": transaction.changeBankAccountDto.reitInvestmentOrderGroupId,
				"Number of Payment Options": transaction.changeBankAccountDto.paymentMethodOptions.length-1
			});
		}

		transactionActivityTable.showChangeBankAccountModal = function(transaction){
			if(angular.isDefined(transaction.changeBankAccountDto)) {
				InvestmentEntityFactory.getPaymentMethodOptions({includePlaid: true})
					.then(function(paymentMethodOptions){
						transaction.changeBankAccountDto.paymentMethodOptions = paymentMethodOptions;
						fireChangeBankAccountMixpanelEvent(transaction);
						$rootScope.ModalFactory.openChangeBankAccount(transaction.changeBankAccountDto);
					});
			}
		};

		transactionActivityTable.fireRedemptionRequestCancellationMixpanelEvent = function(transaction){
			transactionActivityTable.cancelRedemptionRequestTransactionData = {
				redemptionRequestId: transaction.redemptionRequestId,
				type: transaction.type
			};

			mixpanelFactory.track("Show Cancel Redemption Transaction Modal", transactionActivityTable.cancelRedemptionRequestTransactionData);
		};

		transactionActivityTable.showCancelRedemptionRequestModal = function(transaction){
			transactionActivityTable.fireRedemptionRequestCancellationMixpanelEvent(transaction);
			$rootScope.ModalFactory.openCancelRedemptionRequestTransaction(transactionActivityTable.cancelRedemptionRequestTransactionData);
		};
		
		function openDefaultTransaction(){
			var openEditBank = urlFactory.getUrlParamAsBool('editbank');
			var orderNum = urlFactory.getUrlParam('order');

			if(angular.isDefined(orderNum)) {
				transactionActivityTable.transactions.forEach(function(transaction){
					if(transaction.transactionDetails.data['Order #'] === orderNum) {
						transaction.expanded = true;
						if(openEditBank) {
							transactionActivityTable.showChangeBankAccountModal(transaction);
						}
					}
				});
			}
		}

		transactionActivityTable.$onInit = function() {
			transactionActivityTable.cancelTransactionData = {};
			transactionActivityTable.cancelRedemptionRequestTransactionData = {};
			transactionActivityTable.basePath = APP_BASE_PATH;
			transactionActivityTable.dateOptions = getDateOptions();
			transactionActivityTable.typeOptions = getTypeOptions();
			transactionActivityTable.dateFilter = transactionActivityTable.dateOptions[0];
			transactionActivityTable.typeFilter = transactionActivityTable.typeOptions[0];
			transactionActivityTable.showDateFilter = transactionActivityTable.dateOptions.length > 2;
			transactionActivityTable.showTypeFilter = transactionActivityTable.typeOptions.length > 2;
			transactionActivityTable.showFilters = transactionActivityTable.enableFilters && (transactionActivityTable.showDateFilter || transactionActivityTable.showTypeFilter);
			$timeout(openDefaultTransaction);
		};
	}

})(window.angular);
